import { useEffect, useRef, useState } from "react";
import { useLocation } from "@remix-run/react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import GlobalCardDynamicUrl from "./GlobalCardDynamicUrl";
import { ROUTE_LIST_DYNAMIC } from "~/constant/route-list-dynamic";

export default function ExploreJasaByCitySection() {
  const location = useLocation();
  const currentPath = location.pathname;
  const currentCity = currentPath.split("di-")[1]?.split("/")[0];

  const containerRef = useRef<HTMLDivElement>(null);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(true);
  const scrollByAmount = 300;

  const filteredRoutes = ROUTE_LIST_DYNAMIC.filter((item) => {
    const city = item.path.split("di-")[1]?.split("/")[0];
    return city === currentCity && item.path !== currentPath;
  });

  const otherCityRoutes = ROUTE_LIST_DYNAMIC.filter((item) => {
    const city = item.path.split("di-")[1]?.split("/")[0];
    return city && city !== currentCity;
  });

  const checkScroll = () => {
    const el = containerRef.current;
    if (!el) return;
    setShowLeft(el.scrollLeft > 10);
    setShowRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 10);
  };

  const scrollLeft = () => {
    containerRef.current?.scrollBy({
      left: -scrollByAmount,
      behavior: "smooth",
    });
  };

  const scrollRight = () => {
    containerRef.current?.scrollBy({
      left: scrollByAmount,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    checkScroll();
    const handleResize = () => checkScroll();
    const el = containerRef.current;
    el?.addEventListener("scroll", checkScroll);
    window.addEventListener("resize", handleResize);
    return () => {
      el?.removeEventListener("scroll", checkScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const otherCityRef = useRef<HTMLDivElement>(null);
  const [showLeftOther, setShowLeftOther] = useState(false);
  const [showRightOther, setShowRightOther] = useState(true);

  const checkScrollOther = () => {
    const el = otherCityRef.current;
    if (!el) return;
    setShowLeftOther(el.scrollLeft > 10);
    setShowRightOther(el.scrollLeft + el.clientWidth < el.scrollWidth - 10);
  };

  const scrollLeftOther = () => {
    otherCityRef.current?.scrollBy({
      left: -scrollByAmount,
      behavior: "smooth",
    });
  };

  const scrollRightOther = () => {
    otherCityRef.current?.scrollBy({
      left: scrollByAmount,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    checkScrollOther();
    const handleResize = () => checkScrollOther();
    const el = otherCityRef.current;
    el?.addEventListener("scroll", checkScrollOther);
    window.addEventListener("resize", handleResize);
    return () => {
      el?.removeEventListener("scroll", checkScrollOther);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {filteredRoutes.length > 0 && (
        <section className=" w-full  mx-auto py-[3rem] relative">
          <h2 className="ml-[1rem] md:ml-[0rem] mx-auto text-lg font-semibold capitalize">
            Jelajahi jasa di kota {currentCity} berdasarkan
          </h2>

          <div className="relative mt-3">
            {showLeft && (
              <button
                onClick={scrollLeft}
                aria-label="Scroll left"
                className="absolute left-2 top-1/2  transform -translate-y-1/2 z-20 bg-black text-white shadow-md p-1 animate-pulse rounded-full"
              >
                <ChevronLeft size={20} />
              </button>
            )}

            {showRight && (
              <button
                onClick={scrollRight}
                aria-label="Scroll right"
                className="absolute right-2 top-1/2  transform -translate-y-1/2 z-20 bg-black text-white shadow-md p-1 animate-pulse rounded-full"
              >
                <ChevronRight size={20} />
              </button>
            )}

            <div
              ref={containerRef}
              className="overflow-x-auto no-scrollbar w-full"
            >
              <div className="ml-[1rem] md:ml-[0rem] flex flex-row gap-[1rem] w-max">
                <GlobalCardDynamicUrl
                  dynamicUrls={filteredRoutes}
                  currentPath={currentPath}
                />
              </div>
            </div>
          </div>
        </section>
      )}

      {otherCityRoutes.length > 0 && (
        <section className=" pb-[3rem] relative">
          <h2 className="ml-[1rem] md:ml-[0rem] text-lg font-semibold">
            Jelajahi jasa di kota lain
          </h2>

          <div className="relative mt-3">
            {showLeftOther && (
              <button
                onClick={scrollLeftOther}
                aria-label="Scroll left"
                className="absolute left-2 top-1/2  transform -translate-y-1/2 z-20 bg-black text-white shadow-md p-1 animate-pulse rounded-full "
              >
                <ChevronLeft size={20} />
              </button>
            )}

            {showRightOther && (
              <button
                onClick={scrollRightOther}
                aria-label="Scroll right"
                className="absolute right-2 top-1/2  transform -translate-y-1/2 z-20 bg-black text-white shadow-md p-1 animate-pulse rounded-full"
              >
                <ChevronRight size={20} />
              </button>
            )}

            <div
              ref={otherCityRef}
              className="overflow-x-auto no-scrollbar w-full pr-4"
            >
              <div className="ml-[1rem] md:ml-[0rem] flex flex-row gap-[1rem] w-max">
                <GlobalCardDynamicUrl
                  dynamicUrls={otherCityRoutes}
                  currentPath={currentPath}
                />
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
}
